import React from "react";
import NotAuthorisedModal from '../components/modals/NotAuthorisedModal';
import { connect } from 'react-redux';
import { setUser, loginUser, loginError, getUserFromToken, checkUserAuthetication } from '../reducers/actions';
import queryString from 'stringquery';
import { ErrorBoundary } from 'react-error-boundary'
import { Label, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Redirect } from 'react-router-dom';

function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <Modal isOpen={true} className='modal-dialog'>
            <ModalHeader>Something went wrong</ModalHeader>
            <ModalBody>
                <Label>
                    {error.message}
                </Label>
            </ModalBody>
            {/* <ModalFooter>
                <Button color="primary" onClick={resetErrorBoundary}>Try again</Button>
            </ModalFooter> */}
        </Modal>
    )
}

function AuthHOC(WrappedComponent, LOC) {
    return class extends React.Component {
        constructor(props) {
            super(props)

            this.state = {
                //isAuthenticated: localStorage.getItem('token') ? true : false,
                parsed: queryString(this.props.location.search),
                search: this.props.location.search,
                hasError: false,
                errorMessage: ''
            }
        }

        getDisplayName(WrappedComponent) {
            return WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }

        componentDidMount() {
            // The Token may have been stripped from the URL by the X3 parent frame
            // (via history.replaceState) during the async get_flagger call in index.js.
            // index.js saves it to sessionStorage synchronously before yielding, so we
            // read it back here as a fallback. Clear it immediately after use so it
            // is not accidentally reused on a later mount.
            const token = this.state.parsed.Token || sessionStorage.getItem('_x3Token');
            if (token) {
                sessionStorage.removeItem('_x3Token');
                this.props.history.replace(this.props.location.pathname);
                this.props.dispatch(getUserFromToken(token));
                return;
            }

            // Already authenticated — skip the cookie-based server check.
            // This handles navigation between routes after a Token-based login (e.g. Sage X3
            // iframe embedding) where the token is no longer in the URL and third-party cookie
            // blocking prevents the session cookie being sent back on subsequent requests.
            if (this.props.authReducer && this.props.authReducer.isAuthenticated) {
                return;
            }

            // Client-side expiry pre-check: decode the session cookie to avoid a
            // server round-trip when the token is already known to be expired.
            // The express:sess cookie holds base64-encoded JSON containing the JWT.
            // This is read-only — not trusted for auth, only used for expiry timing.
            try {
                const sessCookie = document.cookie
                    .split('; ')
                    .find(c => c.startsWith('express:sess='));
                if (sessCookie) {
                    const pad = s => s + '='.repeat((4 - s.length % 4) % 4);
                    const session = JSON.parse(atob(pad(sessCookie.split('=')[1])));
                    if (session.token) {
                        const payloadB64 = session.token.split('.')[1]
                            .replace(/-/g, '+').replace(/_/g, '/');
                        const payload = JSON.parse(atob(pad(payloadB64)));
                        if (payload.exp && Date.now() / 1000 > payload.exp) {
                            this.props.dispatch(loginError('Your session has expired. Please log in again.'));
                            return;
                        }
                    }
                }
            } catch (_) {
                // Decode failed — fall through to server check
            }

            // First-run setup check: redirect to wizard if no admin account exists yet.
            // Runs in parallel with the auth check so there's no added latency for
            // established installs.
            fetch('/api/setup/status')
                .then(r => r.json())
                .then(data => {
                    if (data.setupRequired) {
                        this.props.history.replace('/auth/setup');
                    }
                })
                .catch(() => {});

            this.props.dispatch(checkUserAuthetication());
        }

        myErrorHandler = (error, info) => {
            // Do something with the error
            // E.g. log to an error logging client here
            console.error(error)
            console.error(info)
        }

        render() {
            const { isAuthenticated, authChecked } = this.props.authReducer
            const { localisation, viewpermissions, requirePasswordChange } = this.props.userReducer;

            // Render nothing while the initial checkToken call is still in flight.
            // Once authChecked is true we know the outcome and can act on it.
            if (!authChecked) {
                return null;
            }

            if (!isAuthenticated) {
                return <Redirect to='/auth/basic' />;
            }

            // Force password change for imported users or any user with the flag set.
            // Redirect to the self-service change password page. Skip if already there
            // to prevent a redirect loop.
            if (requirePasswordChange) {
                const isOnChangePassword = this.props.location.pathname
                    .toLowerCase().includes('changepassword');
                if (!isOnChangePassword) {
                    return <Redirect to='/site/administration/ChangePassword' />;
                }
            }

            //add auth for each page and restrict access
            // Skip view-permission check for X3 token-based access –
            // the user was already authenticated via the Token and
            // document-level permissions still apply at the API layer.
            const isTokenAccess = !!this.state.parsed.Token;

            if (isAuthenticated && viewpermissions && !isTokenAccess) {
                // Detect setup mode: only configuration and/or license are enabled
                const enabledPages = Object.keys(viewpermissions).filter(k => viewpermissions[k]?.enabled);
                const isSetupMode = enabledPages.length > 0 &&
                    enabledPages.every(k => k === 'configuration' || k === 'license');

                var allowed = false;
                Object.keys(viewpermissions).forEach((k, i) => {
                    if (LOC.name === k) {
                        if (viewpermissions[k].enabled)
                            allowed = true;
                    }

                });

                if (!allowed) {
                    if (isSetupMode) {
                        return <Redirect to='/site/config' />
                    }
                    return <NotAuthorisedModal modal={true} />;
                }
            }

            return (
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={this.myErrorHandler}>
                    <WrappedComponent localisation={localisation} isAuthenticated={isAuthenticated} parsed={this.state.parsed} search={this.state.search} {...this.props} />
                </ErrorBoundary>
            )
        };
    }
}

export default AuthHOC;